// extracted by mini-css-extract-plugin
export default {"img":"cardGallery_img__MEdr4","cursor":"cardGallery_cursor__6P7LM","slide":"cardGallery_slide__T2Mbq"};